"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// import JunkOption from './options/JunkOption';
var SignatureOption_1 = require("owa-signature-option/lib/SignatureOption");
var automationSubCategory = {
    key: 'automation',
    titleStringKey: 'optionSubcategory_automation',
    options: [
        // JunkOption,
        SignatureOption_1.default,
    ],
};
exports.default = automationSubCategory;
//# sourceMappingURL=automationSubCategory.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-options-mail/lib/data/automationSubCategory.js
// module id = 5004
// module chunks = 2